import { inject, NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, RouterModule, RouterStateSnapshot, Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';

import { AuthenticationModule } from '@assess/browser/authentication';

import { environment } from '../environments/environment';

export const prodRoutes: Routes = [
  { path: 'auth', loadChildren: () => AuthenticationModule },
  {
    path: '',
    loadChildren: () => import('@assess/app-web/feature-main').then((m) => m.FeatureMainModule),
    canActivate: [
      (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(next, state),
    ],
  },
];

const routes = environment.production
  ? prodRoutes
  : [
      prodRoutes[0],
      {
        path: 'styles',
        loadChildren: () => import('@assess/app-web/feature-styles').then((m) => m.FeatureStylesModule),
      },
      prodRoutes[1],
    ];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes)],
})
export class AppRoutingModule {}
